import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { CourseBundle } from 'lms-api';
import { UserCourseDataService } from 'lms-api';
import { ViewportScroller } from '@angular/common';
import { fromEvent } from 'rxjs';
import { distinctUntilChanged, throttleTime } from 'rxjs/operators';
import { untilDestroyed } from '@ngneat/until-destroy';
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  @ViewChild('header') headerDiv: ElementRef;

  public bundles: CourseBundle[];
  public navCollapsed: boolean = true;

  private lastHeaderResize: number;

  constructor(public ucdService: UserCourseDataService, private vps: ViewportScroller) {
    this.bundles = [];

    fromEvent(window, 'scroll').pipe(
      untilDestroyed(this),
      throttleTime(50, undefined, {leading: true, trailing: true}),
      distinctUntilChanged()
    ).subscribe(
      () => {
        if(Math.max(vps.getScrollPosition()[1], this.lastHeaderResize) - Math.min(vps.getScrollPosition()[1], this.lastHeaderResize) < 40) return;
        this.headerDiv.nativeElement.classList.toggle('isStuck', vps.getScrollPosition()[1] > 40)
        this.lastHeaderResize = vps.getScrollPosition()[1];
      });
  }

  ngOnInit() {
    this.ucdService.Bundles$.subscribe(bundles => {
      this.bundles = bundles;
    });
  }

  ngOnDestroy() { }

}
